import type { FrameName } from "@/game/entities/config";
import useBuildingsStorageStore from "@/store/useBuildingsStorageStore";
import useResourcesStore from "@/store/useResourcesStore";
import type {
	MilestoneInGameRewardBuilding,
	MilestoneInGameRewardCurrency,
} from "@/types/event";
import type {
	GrandPrizeInGameRewardCurrency,
	GrandPrizeInGameRewardItem,
} from "../domain/grandPrizes";

export const applyMilestoneCurrency = (
	reward: MilestoneInGameRewardCurrency | GrandPrizeInGameRewardCurrency,
	reason = "event milestone reward",
): boolean => {
	const amount =
		typeof reward.amount === "function"
			? reward.amount()
			: (reward.amount ?? 0);

	if (!Number.isFinite(amount) || amount <= 0) {
		return false;
	}

	useResourcesStore().increase(reward.currency, amount, reason);
	return true;
};

export const applyMilestoneBuilding = (
	reward: MilestoneInGameRewardBuilding | GrandPrizeInGameRewardItem,
	reason = "event milestone reward",
): boolean => {
	if (!Number.isFinite(reward.amount) || reward.amount <= 0) {
		return false;
	}

	const frameName = reward.frameName?.trim();
	if (!frameName) {
		return false;
	}

	useBuildingsStorageStore().increase(
		frameName as FrameName,
		reward.amount,
		reason,
	);
	return true;
};
